import * as React from 'react';

export interface FirestoreContextType {
  firestore: firebase.firestore.Firestore;
}

const FirestoreContext = React.createContext<FirestoreContextType>({
  firestore: null,
});

export default FirestoreContext;
